import { VStack, chakra } from '@chakra-ui/react';
import React from 'react';

import type { FormFields } from '../types';

import { useI18n } from 'lib/i18n/context';
import FormFieldAddress from 'ui/shared/forms/fields/FormFieldAddress';

import ContractVerificationFormRow from '../ContractVerificationFormRow';
import { CONTRACT_VERIFICATION_FIELD_KEYS } from '../i18n';

interface Props {
  isReadOnly?: boolean;
}

const ContractVerificationFieldAddress = ({ isReadOnly }: Props) => {
  const { t } = useI18n();

  return (
    <VStack align="stretch" spacing={{ base: 2, lg: 3 }}>
      <ContractVerificationFormRow>
        <chakra.span fontWeight={ 500 } fontSize="20px" fontFamily="'Space Grotesk', sans-serif" color="form_input_fg">
          { t(CONTRACT_VERIFICATION_FIELD_KEYS.address.label) }
        </chakra.span>
      </ContractVerificationFormRow>
      <ContractVerificationFormRow>
        <FormFieldAddress<FormFields>
          name="address"
          isRequired
          placeholder={ t(CONTRACT_VERIFICATION_FIELD_KEYS.address.placeholder) }
          isReadOnly={ isReadOnly }
          size={{ base: 'md', lg: 'lg' }}
          inputSx={{
            _dark: {
              '&::placeholder': {
                color: '#616161',
              },
              '&::-webkit-input-placeholder': {
                color: '#616161',
              },
            },
          }}
        />
      </ContractVerificationFormRow>
    </VStack>
  );
};

export default React.memo(ContractVerificationFieldAddress);
